import React, { useState, useEffect } from 'react'
import Topbar from '../components/Layout/Topbar'
import { Sidebar } from '../components/Layout/Sidebar'
import CreateOrderPage from '../components/CreateOrder/CreateOrderPage'
import { addDoc, collection, doc, getDocs, query, runTransaction, updateDoc, where } from 'firebase/firestore'
import { db, storage } from '../firebase.config'
import { pinCodeList } from "../data/pinCodeData"
import { locationPricing } from '../data/LocationPricing'
import ConfirmationModal from '../components/CreateOrder/ConfirmationModal'
import { useDispatch, useSelector } from 'react-redux'
import { saveOrderSupabase } from '../actions/orderAction'
import { useNavigate } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast';
import { getUsersByRole, supabase } from '../supabase.config'
const CreateOrder = () => {
  // const [step, setStep] = useState(1)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { error, loading } = useSelector(
    (state) => state.order
  )
  const { isAuthenticated, users, userProfile } = useSelector(
    (state) => state.user
  )
  const [confirmModal, setConfirmModal] = useState(false)
  const [warehouseList, setWarehouseList] = useState([])
  const [pickupLocation, setPickupLocation] = useState({})
  const [salesInsuranceCharge, setSalesInsuranceCharge] = useState(0)
  const [user, setUser] = useState({})
  const [dimension, setDimension] = useState([])
  const [lrDetails, setLrDetails] = useState("manual")
  const [lrNumber, setLrNumber] = useState("")
  const [orderID, setOrderID] = useState("")
  console.log(lrNumber)
  const [pickupZone, setPickupZone] = useState("")
  const [deliveryZone, setDeliveryZone] = useState("")
  const [baseAmount, setBaseAmount] = useState(0)
  const [userList, setUserList] = useState([])
  const [orderList, setOrderList] = useState([])
  const [invoiceList, setInvoiceList] = useState([])
  const [totalbox, setTotalbox] = useState("")
  const [createdAtInput, setCreatedAtInput] = useState("")
  const [actualdate, setActualdate] = useState("")
  const [salesCharge, setSalesCharge] = useState(0)
  const [consigneeGST, setConsigneeGST] = useState("")
  const [sellerGST, setSellerGST] = useState("")
  const [invoiceDetail, setInvoiceDetail] = useState({
    ident: "",
    n_value: 0,
    ewaybill: ""
  })
  const [invoiceDocument, setInvoiceDocument] = useState("")
  const [supportDocument, setSupportDocument] = useState("")
  const [dimentionData, setDimentionData] = useState({
    name: "",
    qty: "",
    length: "",
    width: "",
    height: ""
  })
  const [volumetricWeight, setVolumetricWeight] = useState(0)
  const handleConfirmModal = () => {
    setConfirmModal(!confirmModal)
  }
  const [subOrders, setSubOrders] = useState([])
  const [subOrder, setSubOrder] = useState({
    ident: "",
    count: "",
    description: "",


  })
  const [dropLocation, setDropLocation] = useState({
    address: "",
    zip: "",
    consignee: "",
    city: "",
    region: "",
    phone: "",
    companyName: ""
  })
  const [mode, setMode] = useState("")
  const [shippingType, setShippingType] = useState("LOC")
  const [amount, setAmount] = useState(null)
  const [purchaseFuel, setPurchaseFuel] = useState(0)
  const [totalHeight, setTotalHeight] = useState(0)
  const [totalBoxQty, setTotalBoxQty] = useState(0)
  const [totalWidth, setTotalWidth] = useState(0)
  const [totalLength, setTotalLength] = useState(0)
  const [weight, setWeight] = useState(null)
  const [salesTotalCharge, setSalesTotalCharge] = useState(0)
  const [totalChargeableWeight, setTotalChargeableWeight] = useState(0)
  const [productlist, setproductlist] = useState({})
  const [totalqty, settotalqty] = useState(0)
  const [totalwidth, setTotalwidth] = useState(0)
  const [totalheight, settotalheight] = useState(0)
  const [loadingOrder, setLoadingOrder] = useState(false)
  const handleDimensionData = () => {

    const totalQauntity = totalqty + Number(dimentionData.qty)
    settotalqty(totalQauntity)

    setTotalLength(totalLength + Number(dimentionData.length))
    settotalheight(totalheight + Number(dimentionData.height))
    setTotalWidth(totalwidth + Number(dimentionData.width))

    setDimension([...dimension, {
      length: Number(dimentionData.length),
      width: Number(dimentionData.width),
      height: Number(dimentionData.height),
      count: Number(dimentionData.qty)

    }])
    const chargableWeight = ((dimentionData.length * dimentionData.width * dimentionData.height) / 4500) * dimentionData.qty
    setTotalChargeableWeight(() => (totalChargeableWeight + Number(chargableWeight)))
    setSubOrders([
      ...subOrders, {
        ident: lrNumber + Number(dimension.length) + 1,
        count: Number(dimentionData.qty),
        description: dimentionData.name,
      }
    ])

    setDimentionData({
      name: "",
      qty: "",
      length: "",
      width: "",
      height: ""
    })
  }
  console.log(totalqty)
  const removeDimesion = (name) => {
    setDimension(
      dimension.filter((item) => item.name !== name)
    )
  }
  console.log(pinCodeList)

  const handleActualdelivery = () => {
    const matchingPin = pinCodeList.find(
      (pinItem) =>
        pinItem.Pin === dropLocation.zip &&
        (pinItem.FacilityCity === "Mumbai" ||
          pinItem.FacilityCity === "Thane" ||
          pinItem.FacilityCity === "Greater Thane")
    );

    if (matchingPin) {
      console.log("aniket bhadwa");
      const nextDay = new Date(); // Assuming createdAt is a valid date
      nextDay.setDate(nextDay.getDate() + 1);
      setActualdate(nextDay);
    }
  };

  const handleShippingDetails = () => {


    // if (weight === null) {
    //   alert("Enter Total Weight")
    // }
    // else if (orderID.length === 0) {
    //   alert("Please enter Order ID")
    // }
    // else if (dimension.length === 0) {
    //   alert("Please enter Dimension")
    // }

    // else {
    //   const date = new Date()
    //   if (Object.keys(pickupLocation).length !== 0) {
    //     pinCodeList.map((zip) => {
    //       if (zip.Pin === Number(pickupLocation.pinCode)) {
    //         setPickupZone(zip.Zone)
    //       }
    //     })
    //   }
    //   if (dimension.length !== 0) {
    //     let Length = 0
    //     let Width = 0
    //     let Height = 0
    //     dimension.map((item) => {
    //       Length = Length + (Number(item.length) * item.count)
    //       Width = Width + (Number(item.width) * item.count)
    //       Height = Height + (Number(item.height) * item.count)
    //     })
    //     setTotalHeight(Height)
    //     setTotalWidth(Width)
    //     setTotalLength(Length)
    //   }
    //   if (orderList?.length !== 0 && lrDetails === "automatic") {
    //     setLrNumber(String(date.getFullYear()) + String((date.getMonth() <= 9 ? "0" + date.getMonth() : date.getMonth())) + String((date.getDate() <= 9 ? "0" + date.getDate() : date.getDate())) + String((Number(orderList.length) + 1)))
    //   }
    //   // setStep(2)
    // }
  }
  const handleDeliveryInformation = () => {
    // if (dropLocation.consignee.length === 0 || dropLocation.address.length === 0 || dropLocation.zip.length === 0 || dropLocation.region.length === 0 || dropLocation.city.length === 0 || dropLocation.phone.length === 0) {
    //   toast.error("Please enter All Delivery Details")
    // }
    // else {
    //   pinCodeList.map((zip) => {
    //     if (zip.Pin === Number(dropLocation.zip)) {
    //       setDeliveryZone(zip.Zone)
    //     }
    //   })
    //   // setStep(3)
    // }
  }
  const handleBookOrder = () => {
    // if (invoiceDetail?.collectionType === "COD" && invoiceDetail?.amountCollection?.length === 0) {
    //   toast.error("Please add Amount to Collect ")
    // }
    // else if (invoiceList?.length === 0) {
    //   toast.error("Please Add Invoice  ")
    // }
    // else {


    //   if (pickupZone.length !== 0 && deliveryZone.length !== 0) {
    //     handleConfirmModal()
    //     locationPricing.map((location) => {
    //       if (location.locationOne === pickupZone && location.locationTwo === deliveryZone) {
    //         setBaseAmount(location.charge)
    //       }
    //     })
    //     if (user?.rateList?.length !== 0) {
    //       user?.rateList?.map((item) => {
    //         if (item?.deliveryLocation === Number(dropLocation.zip) && item?.fromLocation === Number(pickupLocation.pinCode)) {
    //           setSalesCharge((((totalHeight * totalWidth * totalLength) / 4500) * item?.rate) + ((((totalHeight * totalWidth * totalLength) / 4500) * item?.rate) * (item?.fuel / 100)) + item?.lrCharge + item?.fmCost + item?.greenTax + item?.handling + item?.oda)
    //           if (user?.insuranceType === "owner risk") {
    //             setSalesInsuranceCharge(item?.rovOWER)
    //           }
    //           else {
    //             const rateCarrier = (((totalHeight * totalWidth * totalLength) / 4500) * item?.rate) * (item?.fuel / 100)
    //             if (rateCarrier > item?.minRovValue) {
    //               setSalesInsuranceCharge(Math.round(rateCarrier))
    //             }
    //             else {
    //               setSalesInsuranceCharge(item?.minRovValue)
    //             }
    //           }
    //         }
    //       })
    //     }

    //   }
    // }


  }
  console.log(totalChargeableWeight)
  const handleConfirmOrder = async () => {
    if (loadingOrder) return;
    setLoadingOrder(true);

    const createdAt = createdAtInput
      ? new Date(`${createdAtInput}T00:00:00`)
      : new Date();

    if (!weight) {
      alert("Enter Total Weight");
      setLoadingOrder(false);
      return;
    }

    if (!orderID?.length) {
      alert("Please enter Order ID");
      setLoadingOrder(false);
      return;
    }

    if (!dimension?.length) {
      alert("Please enter Dimension");
      setLoadingOrder(false);
      return;
    }

    if (
      !dropLocation.consignee ||
      !dropLocation.address ||
      !dropLocation.zip ||
      !dropLocation.region ||
      !dropLocation.city ||
      !dropLocation.phone
    ) {
      toast.error("Please enter All Delivery Details");
      setLoadingOrder(false);
      return;
    }

    if (pickupLocation?.pinCode) {
      pinCodeList.forEach((zip) => {
        if (zip.Pin === Number(pickupLocation.pinCode)) {
          setPickupZone(zip.Zone);
        }
      });
    }

    if (dropLocation?.zip) {
      pinCodeList.forEach((zip) => {
        if (zip.Pin === Number(dropLocation.zip)) {
          setDeliveryZone(zip.Zone);
        }
      });
    }

    if (dimension.length) {
      let Length = 0, Width = 0, Height = 0;
      dimension.forEach((item) => {
        Length += Number(item.length) * item.count;
        Width += Number(item.width) * item.count;
        Height += Number(item.height) * item.count;
      });
      setTotalHeight(Height);
      setTotalWidth(Width);
      setTotalLength(Length);
    }

    setVolumetricWeight((totalHeight * totalWidth * totalLength) / 4500);
    const baseAmountCalc = ((totalHeight * totalWidth * totalLength) / 4500) * baseAmount;
    setAmount(baseAmountCalc);
    setPurchaseFuel(baseAmountCalc * 0.2);
    setSalesTotalCharge(salesCharge + salesInsuranceCharge);

    if (pickupZone && deliveryZone) {
      locationPricing.forEach((location) => {
        if (
          location.locationOne === pickupZone &&
          location.locationTwo === deliveryZone
        ) {
          setBaseAmount(location.charge);
        }
      });

      user?.rateList?.forEach((item) => {
        if (
          item.deliveryLocation === Number(dropLocation.zip) &&
          item.fromLocation === Number(pickupLocation.pinCode)
        ) {
          const base = ((totalHeight * totalWidth * totalLength) / 4500) * item.rate;
          const fuel = base * (item.fuel / 100);
          const totalSales = base + fuel + item.lrCharge + item.fmCost + item.greenTax + item.handling + item.oda;
          setSalesCharge(totalSales);

          if (user?.insuranceType === "owner risk") {
            setSalesInsuranceCharge(item.rovOWER);
          } else {
            const insurance = Math.round(fuel);
            setSalesInsuranceCharge(
              insurance > item.minRovValue ? insurance : item.minRovValue
            );
          }
        }
      });
    }

    // Actual Delivery Date
    const matchingPin = pinCodeList.find((pinItem) => {
      const zipMatch = Number(pinItem.Pin) === Number(dropLocation.zip);
      const cityMatch = ["Mumbai", "Thane", "Greater Thane"].includes(
        pinItem.FacilityCity?.trim()
      );
      return zipMatch && cityMatch;
    });

    let actualDeliveryDate = matchingPin ? new Date() : null;
    if (actualDeliveryDate) actualDeliveryDate.setDate(actualDeliveryDate.getDate() + 1);

    // Generate LR number (Supabase version): yymmdd + ms suffix
    const now = new Date();
    const dateKey = `${String(now.getFullYear()).slice(-2)}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`
    const ms = String(now.getTime()).slice(-3)
    const generatedLrNo = lrDetails === 'automatic' ? `${dateKey}${ms}` : lrNumber

    // Save Order
    dispatch(saveOrderSupabase({
      ident: "",
      createdAt,
      pickup_location: pickupLocation,
      dropoff_location: dropLocation,
      return_address: dropLocation,
      d_mode: "Prepaid",
      purchaseCharge: baseAmountCalc + Number(purchaseFuel),
      salesCharge: salesTotalCharge,
      orderStatus: "new",
      payment_mode: "Prepaid",
      rov_insurance: user?.insuranceType,
      invoices: invoiceList,
      weight: Number(weight),
      suborders: subOrders,
      dimensions: dimension,
      consignee_gst_tin: consigneeGST,
      seller_gst_tin: sellerGST,
      cb: {},
      totalqty: totalqty,
      orderID: orderID,
      lrno: generatedLrNo,
      shippingType,
      totalChargeableWeight: totalChargeableWeight,
      masterAWB: "",
      uid: user?.uid,
      userName: user?.companyName,
      deliveryactualdate: actualDeliveryDate,
      orderActivity: [{
        status: "Order Created",
        remark: "Order has been Created",
        location: "",
        time: createdAt
      }]
    }))
      .then(() => {
        navigate("/success");
      })
      .catch((err) => {
        console.error("Order save error:", err);
        toast.error("Failed to save order.");
      })
      .finally(() => {
        setLoadingOrder(false);
      });
  };




  const fetchWarehouse = async () => {
    // If a user is selected, filter warehouses by their company name
    let query = supabase.from('warehouses').select('*')
    if (user && user.companyName) {
      query = query.ilike('company_name', `%${user.companyName}%`)
    }
    const { data, error } = await query.order('created_at', { ascending: false })
    if (error) {
      console.error('Failed to fetch warehouses', error)
      return
    }
    const mapped = (data || []).map(w => ({
      id: w.id,
      pickupName: { name: w.name, companyName: w.company_name || '' },
      pinCode: w.pin_code || '',
      city: w.city || '',
      state: w.state || '',
      country: w.country || '',
      address: w.address || '',
      personName: w.contact_person || '',
      email: '',
      phone: w.contact_number || '',
      slot: w.preferred_slot || ''
    }))
    setWarehouseList(mapped)
  }
  console.log(user, warehouseList)
  const fetchUsers = async () => {
    try {
      // Only fetch clients for logistics service
      const { data, error } = await getUsersByRole('client', 'logistics')
      
      if (error) {
        console.error("Error fetching users:", error)
        return
      }
      
      // Transform the data to match the expected format
      const users = data.map((user) => ({
        id: user.id,
        uid: user.id,
        name: user.name,
        email: user.email,
        contact: user.contact,
        companyName: user.company_name,
        gstNo: user.gst_no,
        gstDocument: user.gst_document,
        agreement: user.agreement,
        otherDoc: user.other_doc,
        insuranceType: user.insurance_type,
        companyAddress: user.company_address,
        role: user.role,
        partnerType: user.partner_type,
        walletBalance: user.wallet_balance,
        service: user.service,
        rateList: user.rate_list,
        createdAt: user.created_at,
        updatedAt: user.updated_at
      }))
      
      setUserList(users)
    } catch (error) {
      console.error("Error fetching users:", error)
    }
  }
  console.log(pickupZone, deliveryZone, baseAmount, amount)
  console.log(totalHeight, totalLength, totalWidth, volumetricWeight)
  const fetchOrders = async () => {
    const q = query(collection(db, "logisticOrder"))
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      setOrderList((prev) => [...prev, {
        id: doc.id,
        ...doc.data()
      }])


    });
  }


  // Dilvery Funtion 
  const [deliveryAddresses, setDeliveryAddresses] = useState([]);
  const fetchDeliveryAddresses = async () => {
    const { data, error } = await supabase.from('delivery_addresses').select('*').order('created_at', { ascending: false })
    if (error) {
      console.warn('Failed to fetch delivery addresses (ensure table exists)', error)
      return
    }
    const mapped = (data || []).map(d => ({
      deliveryAddress: d.delivery_address,
      deliveryName: d.delivery_name,
      deliveryPhone: d.delivery_phone,
      deliveryCompanyName: d.delivery_company_name,
      deliveryPincode: d.delivery_pincode,
      deliveryCity: d.delivery_city,
      deliveryState: d.delivery_state,
      deliveryClientId: d.delivery_client_id
    }))
    setDeliveryAddresses(mapped)
  };

  useEffect(() => {
    fetchDeliveryAddresses();
  }, []);

  const addInvoice = (e) => {
    e.preventDefault();
    const fileName = e.target[0]?.files?.[0]?.name || "";
    setInvoiceDocument(fileName);
  };

  const addSupport = (e) => {
    e.preventDefault();
    const fileName = e.target[0]?.files?.[0]?.name || "";
    setSupportDocument(fileName);
  };


  console.log(deliveryAddresses)

  console.log(lrNumber)
  useEffect(() => {
    if (Object.keys(user).length !== 0) {
      fetchWarehouse()
    }
    // fetchOrders()
    fetchUsers()
  }, [user]);

  console.log(salesCharge)
  console.log(lrNumber)

  return (
    <>
      <div className='bg-gray-50 flex min-h-screen'>

        <Toaster />
        <Sidebar />
        <ConfirmationModal confirmModal={confirmModal} handleConfirmOrder={handleConfirmOrder} handleConfirmModal={handleConfirmModal} />
        <div className='h-[100vh] overflow-y-scroll flex flex-1 flex-col' >

          <Topbar />
          <div className='flex-1 pb-6'>
          <CreateOrderPage
            deliveryAddresses={deliveryAddresses}
            loadingOrder={loadingOrder}
            loading={loading}
            totalbox={totalbox}
            setTotalbox={setTotalbox}
            userList={userList}
            setUserList={setUserList}
            user={user}
            setUser={setUser}
            handleBookOrder={handleBookOrder}
            handleConfirmOrder={handleConfirmOrder}
            handleDeliveryInformation={handleDeliveryInformation}
            warehouseList={warehouseList}
            pickupLocation={pickupLocation}
            setPickupLocation={setPickupLocation}
            handleShippingDetails={handleShippingDetails}
            removeDimesion={removeDimesion}
            handleDimensionData={handleDimensionData}
            dimentionData={dimentionData}
            setDimentionData={setDimentionData}
            setDimension={setDimension}
            dimension={dimension}
            subOrders={subOrders}
            setSubOrders={setSubOrders}
            dropLocation={dropLocation}
            setDropLocation={setDropLocation}
            mode={mode}
            setMode={setMode}
            shippingType={shippingType}
            setShippingType={setShippingType}
            amount={amount}
            setAmount={setAmount}
            weight={weight}
            setWeight={setWeight}
            lrNumber={lrNumber}
            setLrNumber={setLrNumber}
            orderID={orderID}
            orderList={orderList}
            setOrderID={setOrderID}
            lrDetails={lrDetails}
            setLrDetails={setLrDetails}
            createdAtInput={createdAtInput}
            setCreatedAtInput={setCreatedAtInput}
            consigneeGST={consigneeGST}
            setConsigneeGST={setConsigneeGST}
            sellerGST={sellerGST}
            setSellerGST={setSellerGST}
            invoiceDetail={invoiceDetail}
            setInvoiceDetail={setInvoiceDetail}
            invoiceDocument={invoiceDocument}
            supportDocument={supportDocument}
            invoiceList={invoiceList}
            setInvoiceList={setInvoiceList}
            addInvoice={addInvoice}
            addSupport={addSupport}
          // step={step} setStep={setStep}
          />
          </div>
        </div>
      </div>
    </>
  )
}

export default CreateOrder
